import formStyles from '../../../components/form/form.module.scss';
import {Button} from '../../../components/button/button';
import {__} from '../../../support/lang/translations';
import {ButtonColorType} from '../../../enums/button_color_type.ts';
import {List} from '../../../components/list/list.tsx';
import {useAppSelector} from '../../../store/store.ts';
import {Status} from '../../../enums/status.ts';
import {CenteredSpinner} from '../../../components/spinner/centered_spinner.tsx';
import {VehicleListItem} from '../../../components/vehicle/vehicle_list_item.tsx';
import {AltButton} from '../../../components/button/alt_button.tsx';
import {Vehicle} from '../../../gql/customer/graphql.ts';
import buttonStyles from '../../../components/button/button.module.scss';

export function VehicleDetailsTitle() {
    return (
        <>
            <h1>{__('onboarding.vehicles.title')}</h1>
            <h2>{__('onboarding.vehicles.subtitle')}</h2>
        </>
    );
}

interface ContentProps {
    isEditing: boolean;
    onEditClick: () => void;
    onDeleteClick: (vehicle: Vehicle | null) => void;
}
export function VehicleDetailsContent(props: ContentProps) {
    const customerInfo = useAppSelector((state) => state.customerInfo);

    if (customerInfo.status !== Status.FULFILLED) {
        return <CenteredSpinner />;
    }

    const vehicles = customerInfo.me?.customer?.vehicles;
    return (
        <>
            <h2>{__('onboarding.vehicles.content_title')}</h2>

            <div className={formStyles.form} onClick={() => props.onEditClick()}>
                {vehicles?.length && vehicles.length > 0 ? (
                    <List>
                        {vehicles?.map((vehicle, key) => (
                            <VehicleListItem
                                vehicle={vehicle}
                                key={key}
                                button={
                                    <AltButton
                                        type="button"
                                        noBorder={true}
                                        onClick={() => props.onDeleteClick(vehicle)}
                                    >
                                        <i className="fa-light fa-trash" />
                                    </AltButton>
                                }
                            />
                        ))}
                    </List>
                ) : (
                    <span>{__('onboarding.vehicles.no_vehicles')}</span>
                )}
            </div>
        </>
    );
}

interface FooterProps {
    onCreateVehicle: () => void;
    onPrevSlide: () => void;
    onNextSlide: () => void;
}
export function VehicleDetailsFooter(props: FooterProps) {
    return (
        <>
            <div>
                <div>
                    <Button
                        className={buttonStyles.button_step}
                        type="button"
                        onClick={() => props.onCreateVehicle()}
                        colorType={ButtonColorType.Black}
                    >
                        <i className="fa-light fa-plus" />
                        <span>{__('onboarding.vehicles.buttons.add_vehicle')}</span>
                    </Button>
                </div>
            </div>
            <div>
                <Button
                    className={buttonStyles.button_step}
                    type="button"
                    onClick={() => props.onNextSlide()}
                    colorType={ButtonColorType.Green}
                >
                    <i className="fa-light fa-check" />
                    <span>{__('onboarding.vehicles.buttons.valid')}</span>
                </Button>
            </div>
        </>
    );
}
